import { render, staticRenderFns } from "./content.vue?vue&type=template&id=b0bf3efa&scoped=true"
import script from "./content.vue?vue&type=script&lang=ts"
export * from "./content.vue?vue&type=script&lang=ts"
import style0 from "./content.vue?vue&type=style&index=0&id=b0bf3efa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bf3efa",
  null
  
)

export default component.exports